import { createSlice } from "@reduxjs/toolkit";

// Global "which branch am I looking at" selector (handoff §13.1) - session-only
// (not persisted), so it always starts on "All branches" after a fresh login
// rather than risking a stale branch surviving a token/permission change.
const initialState = {
  selectedBranchId: null, // null = All branches
};

const branchFilterSlice = createSlice({
  name: "branchFilter",
  initialState,
  reducers: {
    branchSelected: (state, action) => {
      state.selectedBranchId = action.payload ?? null;
    },
  },
});

export const { branchSelected } = branchFilterSlice.actions;
export default branchFilterSlice.reducer;

export const selectSelectedBranchId = (state) => state.branchFilter.selectedBranchId;
